import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Approved from "../../../../../assets/images/approved.png";
import Pending from "../../../../../assets/images/pending 2.png";
import Add from "../../../../../assets/images/UpcomingEvent/add 1.png";
import "./SuperStarContent.css";

const Nav = () => {
  const [approved, setApproved] = useState();
  const [pending, setPending] = useState();

  

  //Fetch Approved LiveChat
  useEffect(() => {
    axios.get(`/api/admin/live_chat/count`).then((res) => {
      if (res.status === 200) {
        setApproved(res.data.approved);
      }
    });
  }, []);
  useEffect(() => {
    axios.get(`/api/admin/live_chat/count`).then((res) => {
      if (res.status === 200) {
        setPending(res.data.pending);
      }
    });
  }, []);

  return (
    <>
      <div className="mb-3 row">
        <div
          title="Live Now"
          className="col-md-3 align-items-center justify-content-center "
        >
          <div className="card card-bg nav-body-dashboard mb-3">
            <div className="card-body  align-items-center">
              <center>
                <tr>
                  <td className="livechat-card-td">
                    <img src={Approved} className="img-top" alt="..." />
                  </td>
                  <td className="livechat-card-td">
                    <small className="p-3 fw-bold rounded-1 text-warning textFontResult">
                      {approved}
                    </small>
                  </td>
                </tr>
              </center>
            </div>
            <Link
              to="/superstar-admin/live-chat/live"
              className="card-footer livechat-card-footer"
            >
              <button
                className="livechat-card-footer"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                {" "}
                Live Now
              </button>
            </Link>
          </div>
        </div>
        <br />

        <div
          title="Live Now"
          className="col-md-3 align-items-center justify-content-center "
        >
          <div className="card card-bg nav-body-dashboard mb-3">
            <div className="card-body  align-items-center">
              <center>
                <tr>
                  <td className="livechat-card-td">
                    <img src={Pending} className="img-top" alt="..." />
                  </td>
                  <td className="livechat-card-td">
                    <small className="p-3 fw-bold rounded-1 text-warning textFontResult">
                      {pending}
                    </small>
                  </td>
                </tr>
              </center>
            </div>
            <Link
              to="/superstar-admin/live-chat/pending"
              className="card-footer livechat-card-footer"
            >
              <button
                className="livechat-card-footer"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                Pending
              </button>
            </Link>
          </div>
        </div>
        <br />

        <div
          title="Live Now"
          className="col-md-3 align-items-center justify-content-center "
        >
          <div className="card card-bg nav-body-dashboard mb-3">
            <div className="card-body  align-items-center">
              <center>
                <tr>
                  <td className="livechat-card-td">
                    <img src={Add} className="img-top" alt="..." />
                  </td>
                  <td className="livechat-card-td">
                    <small className="p-3 fw-bold rounded-1 text-warning textFontResult"></small>
                  </td>
                </tr>
              </center>
            </div>
            <Link
              to="/superstar-admin/live-chat/create"
              className="livechat-card-footer"
            >
              <button
                className="card-footer livechat-card-footer"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                {" "}
                Create Live Chat Event
              </button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Nav;
